<ng-container *ngFor="let form of forms$ | async; let index = index">
  <p-sidebar
    [visible]="form.isShowSidebar"
    (visibleChange)="closeSidebar($event, index)"
    position="right"
    [blockScroll]="true"
    [styleClass]="
      form.widthSize +
      ' ' +
      form.typeZIndex +
      ' frm-filters-ui-v2' +
      (form.type === TypeFormEnum.ROOM ? ' room-form-sidebar' : '')
    ">
    <ng-template pTemplate="header">
      @if (form.type === TypeFormEnum.ROOM) {
        <div class="room-form-sidebar-header flex align-items-center justify-content-between gap-3 flex-grow-1 min-w-0 w-full">
          <div class="flex align-items-center gap-3 flex-1 min-w-0">
            <span class="room-form-sidebar-header__icon-box flex-shrink-0">
              <i
                class="pi pi-file-edit room-form-sidebar-header__doc-icon"
                aria-hidden="true"></i>
            </span>
            <div class="min-w-0">
              <p class="room-form-sidebar-header__title m-0">{{ form.headerText }}</p>
              <p class="room-form-sidebar-header__subtitle m-0 mt-1">Заполните реквизиты помещения</p>
            </div>
          </div>
          @if (form.isShowShare) {
            <div class="flex-shrink-0 room-form-sidebar-header__actions">
              <i
                class="pi pi-external-link cursor-pointer room-form-sidebar-header__share-icon"
                pTooltip="Поделиться"
                [showDelay]="300"
                tooltipPosition="bottom"
                role="button"
                tabindex="0"
                (click)="shareLinkForm(index)"
                (keyup.enter)="shareLinkForm(index)"></i>
            </div>
          }
        </div>
      } @else {
        <div class="flex align-items-center justify-content-between gap-3 w-full">
          <p class="text-2xl font-bold">{{ form.headerText }}</p>
          @if (form.isShowShare || (form.type === TypeFormEnum.NET_PING_DEVICE && entityId(index))) {
            <div>
              @if (form.type === TypeFormEnum.NET_PING_DEVICE && entityId(index)) {
                <crm-net-ping-device-barrier-status
                  styleClass="mr-3"
                  [deviceId]="entityId(index)"></crm-net-ping-device-barrier-status>
              }

              @if (form.isShowShare) {
                <i
                  class="pi pi-external-link cursor-pointer text-gray-500 hover:frm-color-blue mr-3"
                  pTooltip="Поделиться"
                  [showDelay]="300"
                  tooltipPosition="bottom"
                  style="font-size: 1.1rem"
                  (click)="shareLinkForm(index)"></i>
              }
            </div>
          }
        </div>
      }
    </ng-template>
    <ng-container [ngSwitch]="form.type">
      <crm-budget-task-form-sidebar
        *ngSwitchCase="TypeFormEnum.BUDGET_TASK"
        [index]="index"></crm-budget-task-form-sidebar>
      <crm-rate-plan-form
        *ngSwitchCase="TypeFormEnum.RATE_PLAN"
        [index]="index"></crm-rate-plan-form>
      <crm-contragent-form
        *ngSwitchCase="TypeFormEnum.CONTRAGENT"
        [index]="index"></crm-contragent-form>
      <crm-planned-income-form
        *ngSwitchCase="TypeFormEnum.PLANNED_INCOME"
        [index]="index"></crm-planned-income-form>
      <crm-group-planned-income-form
        *ngSwitchCase="TypeFormEnum.GROUP_PLANNED_INCOME"
        [index]="index"></crm-group-planned-income-form>
      <crm-direction-form
        *ngSwitchCase="TypeFormEnum.DIRECTION"
        [index]="index"></crm-direction-form>
      <crm-direction-group-form
        *ngSwitchCase="TypeFormEnum.DIRECTION_GROUP"
        [index]="index"></crm-direction-group-form>
      <crm-unit-form
        *ngSwitchCase="TypeFormEnum.UNIT"
        [index]="index"></crm-unit-form>
      <crm-filial-form
        *ngSwitchCase="TypeFormEnum.FILIAL"
        [index]="index"></crm-filial-form>
      <crm-room-form
        *ngSwitchCase="TypeFormEnum.ROOM"
        [index]="index"></crm-room-form>
      <crm-document-type-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_TYPE"
        [index]="index"></crm-document-type-form>
      <crm-operation-type-form
        *ngSwitchCase="TypeFormEnum.OPERATION_TYPE"
        [index]="index"></crm-operation-type-form>
      <crm-operation-type-erp-1c-form
        *ngSwitchCase="TypeFormEnum.OPERATION_TYPE_ERP_1C"
        [index]="index"></crm-operation-type-erp-1c-form>
      <crm-project-master-milestone-form
        *ngSwitchCase="TypeFormEnum.MASTER_MILESTONE"
        [index]="index"></crm-project-master-milestone-form>
      <crm-approval-scheme-form
        *ngSwitchCase="TypeFormEnum.APPROVAL_SCHEME"
        [index]="index"></crm-approval-scheme-form>
      <crm-planning-scenario-form
        *ngSwitchCase="TypeFormEnum.PLANNING_SCENARIO"
        [index]="index"></crm-planning-scenario-form>
      <crm-task-form-sidebar
        *ngSwitchCase="TypeFormEnum.PAYMENT_TASK"
        [index]="index"></crm-task-form-sidebar>
      <crm-task-template-form
        *ngSwitchCase="TypeFormEnum.PAYMENT_TEMPLATE"
        [index]="index"></crm-task-template-form>
      <crm-payment-status-form
        *ngSwitchCase="TypeFormEnum.PAYMENT_STATUS"
        [index]="index"></crm-payment-status-form>
      <crm-database1c-form
        *ngSwitchCase="TypeFormEnum.DATABASE_1C"
        [index]="index"></crm-database1c-form>
      <crm-company-form
        *ngSwitchCase="TypeFormEnum.COMPANY"
        [index]="index"></crm-company-form>
      <crm-company-group-form
        *ngSwitchCase="TypeFormEnum.COMPANY_GROUP"
        [index]="index"></crm-company-group-form>
      <crm-client-form
        *ngSwitchCase="TypeFormEnum.CLIENT"
        [index]="index"></crm-client-form>
      <crm-external-user-create-form
        *ngSwitchCase="TypeFormEnum.EXTERNAL_USER_CREATE"
        [index]="index"></crm-external-user-create-form>
      <crm-external-user-edit-form
        *ngSwitchCase="TypeFormEnum.EXTERNAL_USER_EDIT"
        [index]="index"></crm-external-user-edit-form>
      <crm-user-create-form
        *ngSwitchCase="TypeFormEnum.USER_CREATE"
        [index]="index"></crm-user-create-form>
      <crm-user-edit-form
        *ngSwitchCase="TypeFormEnum.USER_EDIT"
        [index]="index"></crm-user-edit-form>
      <crm-user-group-form
        *ngSwitchCase="TypeFormEnum.USER_GROUP"
        [index]="index"></crm-user-group-form>
      <crm-role-form
        *ngSwitchCase="TypeFormEnum.ROLE"
        [index]="index"></crm-role-form>
      <crm-schedule-form
        *ngSwitchCase="TypeFormEnum.WORK_SCHEDULE"
        [index]="index"></crm-schedule-form>
      <crm-extension1c-form
        *ngSwitchCase="TypeFormEnum.EXTENSION_1C"
        [index]="index"></crm-extension1c-form>
      <crm-changelog-form
        *ngSwitchCase="TypeFormEnum.CHANGELOG"
        [index]="index"></crm-changelog-form>
      <crm-deal-group-form
        *ngSwitchCase="TypeFormEnum.DEAL_GROUP"
        [index]="index"></crm-deal-group-form>
      <crm-deal-form-sidebar
        *ngSwitchCase="TypeFormEnum.DEAL"
        [index]="index"></crm-deal-form-sidebar>
      <crm-exclusion-form
        *ngSwitchCase="TypeFormEnum.EXCLUSION"
        [index]="index"></crm-exclusion-form>
      <crm-newsletter-form-sidebar
        *ngSwitchCase="TypeFormEnum.NEWSLETTER"
        [index]="index"></crm-newsletter-form-sidebar>
      <crm-newsletter-template-form-sidebar
        *ngSwitchCase="TypeFormEnum.NEWSLETTER_TEMPLATE"
        [index]="index"></crm-newsletter-template-form-sidebar>
      <crm-debt-collection-task-form
        *ngSwitchCase="TypeFormEnum.DEBT_COLLECTION_TASK"
        [index]="index"></crm-debt-collection-task-form>
      <crm-helpdesk-task-form
        *ngSwitchCase="TypeFormEnum.HELPDESK"
        [index]="index"></crm-helpdesk-task-form>
      <crm-helpdesk-accept-task-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_ACCEPT_TASK"
        [index]="index"></crm-helpdesk-accept-task-form>
      <crm-helpdesk-template-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_TEMPLATE"
        [index]="index"></crm-helpdesk-template-form>
      <crm-helpdesk-task-type-form
        *ngSwitchCase="TypeFormEnum.HELPDESK_TASK_TYPE"
        [index]="index"></crm-helpdesk-task-type-form>
      <crm-eav-entity-type-form
        *ngSwitchCase="TypeFormEnum.EAV_ENTITY_TYPE"
        [index]="index"></crm-eav-entity-type-form>
      <crm-project-form
        *ngSwitchCase="TypeFormEnum.PROJECT"
        [index]="index"></crm-project-form>
      <crm-project-template-form
        *ngSwitchCase="TypeFormEnum.PROJECT_TEMPLATE"
        [index]="index"></crm-project-template-form>
      <crm-balance-custom-row-form
        *ngSwitchCase="TypeFormEnum.BALANCE_CUSTOM_ROW"
        [index]="index"></crm-balance-custom-row-form>
      <crm-balance-report-format-form
        *ngSwitchCase="TypeFormEnum.BALANCE_REPORT_FORMAT"
        [index]="index"></crm-balance-report-format-form>
      <crm-document-form-sidebar
        *ngSwitchCase="TypeFormEnum.DOCUMENT"
        [index]="index"></crm-document-form-sidebar>
      <crm-document-template-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_TEMPLATE"
        [index]="index"></crm-document-template-form>
      <crm-document-regulation-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_REGULATION"
        [index]="index"></crm-document-regulation-form>
      <crm-contract-form
        *ngSwitchCase="TypeFormEnum.CONTRACT"
        [index]="index"></crm-contract-form>
      <crm-group-contract-form
        *ngSwitchCase="TypeFormEnum.GROUP_CONTRACT"
        [index]="index"></crm-group-contract-form>
      <crm-document-salary-distribution-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_DISTRIBUTION"
        [index]="index"></crm-document-salary-distribution-form>
      <crm-document-salary-accrual-form
        *ngSwitchCase="TypeFormEnum.SALARY_ACCRUAL"
        [index]="index"></crm-document-salary-accrual-form>
      <crm-nomenclature-form
        *ngSwitchCase="TypeFormEnum.NOMENCLATURE"
        [index]="index"></crm-nomenclature-form>
      <crm-nomenclature-group-form
        *ngSwitchCase="TypeFormEnum.NOMENCLATURE_GROUP"
        [index]="index"></crm-nomenclature-group-form>
      <crm-converter-form
        *ngSwitchCase="TypeFormEnum.CONVERTER"
        [index]="index"></crm-converter-form>
      <crm-access-card-form
        *ngSwitchCase="TypeFormEnum.ACCESS_CARD"
        [index]="index"></crm-access-card-form>
      <crm-user-delegation-form
        *ngSwitchCase="TypeFormEnum.USER_DELEGATION"
        [index]="index"></crm-user-delegation-form>
      <crm-kkt-form
        *ngSwitchCase="TypeFormEnum.KKT"
        [index]="index"></crm-kkt-form>
      <crm-type-of-activity-form
        *ngSwitchCase="TypeFormEnum.TYPE_OF_ACTIVITY"
        [index]="index"></crm-type-of-activity-form>
      <crm-lk-eu-helpdesk-task-form
        *ngSwitchCase="TypeFormEnum.LK_EU_HELPDESK"
        [index]="index"></crm-lk-eu-helpdesk-task-form>
      <crm-lk-eu-transit-task-form
        *ngSwitchCase="TypeFormEnum.LK_EU_TRANSIT_TASK"
        [index]="index"></crm-lk-eu-transit-task-form>
      <crm-lk-eu-resident-car-form
        *ngSwitchCase="TypeFormEnum.LK_EU_RESIDENT_CAR"
        [index]="index"></crm-lk-eu-resident-car-form>
      <crm-lk-eu-passage-task-form
        *ngSwitchCase="TypeFormEnum.LK_EU_PASSAGE_TASK"
        [index]="index"></crm-lk-eu-passage-task-form>
      <crm-lk-eu-passage-order-form
        *ngSwitchCase="TypeFormEnum.LK_EU_PASSAGE_ORDER"
        [index]="index"></crm-lk-eu-passage-order-form>
      <crm-lk-eu-external-user-create-form
        *ngSwitchCase="TypeFormEnum.LK_EU_EXTERNAL_USER_CREATE"
        [index]="index"></crm-lk-eu-external-user-create-form>
      <crm-lk-eu-external-user-edit-form
        *ngSwitchCase="TypeFormEnum.LK_EU_EXTERNAL_USER_EDIT"
        [index]="index"></crm-lk-eu-external-user-edit-form>
      <crm-cost-center-form
        *ngSwitchCase="TypeFormEnum.COST_CENTER"
        [index]="index"></crm-cost-center-form>
      <crm-traffic-adapter-form
        *ngSwitchCase="TypeFormEnum.TRAFFIC_ADAPTER"
        [index]="index"></crm-traffic-adapter-form>
      <crm-payer-status-form
        *ngSwitchCase="TypeFormEnum.PAYER_STATUS"
        [index]="index"></crm-payer-status-form>
      <crm-budget-classification-code-form
        *ngSwitchCase="TypeFormEnum.KBK"
        [index]="index"></crm-budget-classification-code-form>
      <crm-revenue-admin-form
        *ngSwitchCase="TypeFormEnum.REVENUE_ADMIN"
        [index]="index"></crm-revenue-admin-form>
      <crm-currency-form
        *ngSwitchCase="TypeFormEnum.CURRENCY"
        [index]="index"></crm-currency-form>
      <crm-task-scenario-form
        *ngSwitchCase="TypeFormEnum.TASK_SCENARIO"
        [index]="index"></crm-task-scenario-form>
      <crm-transit-task-form
        *ngSwitchCase="TypeFormEnum.TRANSIT_TASK"
        [index]="index"></crm-transit-task-form>
      <crm-resident-car-form
        *ngSwitchCase="TypeFormEnum.RESIDENT_CAR"
        [index]="index"></crm-resident-car-form>
      <crm-net-ping-device-form
        *ngSwitchCase="TypeFormEnum.NET_PING_DEVICE"
        [index]="index"></crm-net-ping-device-form>
      <crm-hikvision-camera-form
        *ngSwitchCase="TypeFormEnum.HIKVISION_CAMERA"
        [index]="index"></crm-hikvision-camera-form>
      <crm-storage-form
        *ngSwitchCase="TypeFormEnum.STORAGE_FORM"
        [index]="index"></crm-storage-form>
      <crm-bucket-form
        *ngSwitchCase="TypeFormEnum.BUCKET_FORM"
        [index]="index"></crm-bucket-form>
      <crm-banner-form
        *ngSwitchCase="TypeFormEnum.BANNER"
        [index]="index"></crm-banner-form>
      <crm-passage-task-form
        *ngSwitchCase="TypeFormEnum.PASSAGE_TASK"
        [index]="index"></crm-passage-task-form>
      <crm-passage-order-form
        *ngSwitchCase="TypeFormEnum.PASSAGE_ORDER"
        [index]="index"></crm-passage-order-form>
      <crm-ai-agent-form
        *ngSwitchCase="TypeFormEnum.AI_AGENT"
        [index]="index"></crm-ai-agent-form>
      <crm-ai-knowledge-base-form
        *ngSwitchCase="TypeFormEnum.AI_KNOWLEDGE_BASE"
        [index]="index"></crm-ai-knowledge-base-form>
      <crm-document-file-template-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_FILE_TEMPLATE"
        [index]="index"></crm-document-file-template-form>
      <crm-document-file-template-key-form
        *ngSwitchCase="TypeFormEnum.DOCUMENT_FILE_TEMPLATE_KEY"
        [index]="index"></crm-document-file-template-key-form>
      <crm-deal-type-form
        *ngSwitchCase="TypeFormEnum.DEAL_TYPE"
        [index]="index"></crm-deal-type-form>
      <crm-deal-status-form
        *ngSwitchCase="TypeFormEnum.DEAL_STATUS"
        [index]="index"></crm-deal-status-form>
    </ng-container>
    <ng-template pTemplate="footer">
      <div class="flex flex-wrap align-items-center justify-content-between">
        <div>
          <div
            *ngIf="!form.isEdit && !form.loading && form.isShowRedirectInCreate"
            class="field-checkbox">
            <p-checkbox
              [ngModel]="form.isRedirectInCreate"
              (ngModelChange)="toggleIsRedirectInCreate($event, index)"
              [binary]="true"
              inputId="isRedirectInCreate"></p-checkbox>
            <label [for]="'isRedirectInCreate'">Перейти в карточку при создании</label>
          </div>
        </div>

        @if (!isLk) {
          <crm-voice-assistant-modal></crm-voice-assistant-modal>
        }
      </div>
    </ng-template>
  </p-sidebar>
</ng-container>
